/* ==========================================================================
   ld-swatch.js  —  集合页 / 首页 / 产品页「相关产品」的卡片色块 ↔ 主图联动
   2026-10-13  由 card-product.liquid 内联脚本抽成全局资产（innerHTML 注入场景也要生效）
   依赖：custom.css 里的 .ld-swatch* 样式 + .ld-swatch-hovering 压制 Dawn 第二张图
   ========================================================================== */
/* ld collection-card swatch -> image link (hover + click), 2026-10-13 */
(function () {
  if (window.ldSwatchInit) return;
  window.ldSwatchInit = true;

  var canHover = true;
  try { canHover = window.matchMedia('(hover: hover)').matches; } catch (e) {}

  function cardOf(el) { return (el.closest && (el.closest('.card-wrapper') || el.closest('.card'))) || null; }
  function imgOf(card) {
    if (!card) return null;
    var box = card.querySelector('.card__media') || card.querySelector('.card__inner');
    return box ? box.querySelector('img') : null;
  }
  function applyImg(img, url) {
    if (!img || !url) return;
    if (img.dataset.ldCur === url) return;
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.removeAttribute('width');
    img.removeAttribute('height');
    img.src = url;
    img.dataset.ldCur = url;
  }
  function rememberBase(img) {
    if (img && img.dataset.ldBase == null) {
      img.dataset.ldBase = img.getAttribute('src') || '';
      img.dataset.ldCur = img.dataset.ldBase;
    }
  }
  function preloadRow(row) {
    if (!row || row.dataset.ldPre === '1') return;
    row.dataset.ldPre = '1';
    var list = row.querySelectorAll('.ld-swatch');
    for (var i = 0; i < list.length; i++) {
      var url = list[i].dataset.ldImg;
      if (!url) continue;
      var im = new Image();
      im.decoding = 'async';
      im.src = url;
    }
  }

  /* ---- hover：进入色块 -> 换成该颜色图 ---- */
  document.addEventListener('pointerover', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var sw = t.closest('.ld-swatch');
    if (!sw) {
      var row0 = t.closest('.ld-swatches');
      if (row0) preloadRow(row0);
      return;
    }
    if (!canHover) return;
    var card = cardOf(sw);
    var img = imgOf(card);
    if (!img) return;
    rememberBase(img);
    applyImg(img, sw.dataset.ldImg);
    if (card) card.classList.add('ld-swatch-hovering');
  }, true);

  /* ---- mouseout：离开整行色块 -> 还原 ---- */
  document.addEventListener('pointerout', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var row = t.closest('.ld-swatches');
    if (!row) return;
    var to = e.relatedTarget;
    if (to && row.contains(to)) return;
    var card = cardOf(row);
    if (card) card.classList.remove('ld-swatch-hovering');
    var img = imgOf(card);
    if (img && img.dataset.ldBase != null) applyImg(img, img.dataset.ldBase);
  }, true);

  /* ---- click：固定选中（保留原有行为） ---- */
  document.addEventListener('click', function (e) {
    var sw = e.target && e.target.closest ? e.target.closest('.ld-swatch') : null;
    if (!sw) return;
    e.preventDefault();
    e.stopPropagation();
    var card = cardOf(sw);
    var img = imgOf(card);
    if (img) {
      var url = sw.dataset.ldImg || '';
      applyImg(img, url);
      img.dataset.ldBase = url;   /* 新基准：移出后停在这张 */
    }
    var row = sw.parentElement;
    var prev = row ? row.querySelector('.ld-swatch.is-active') : null;
    if (prev) prev.classList.remove('is-active');
    sw.classList.add('is-active');
  }, true);

  /* ---- 提前预载，避免首次悬停闪白 ---- */
  function fire(row) {
    if (window.requestIdleCallback) window.requestIdleCallback(function () { preloadRow(row); }, { timeout: 1200 });
    else setTimeout(function () { preloadRow(row); }, 200);
  }
  var io = null;
  if ('IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (!entries[i].isIntersecting) continue;
        io.unobserve(entries[i].target);
        fire(entries[i].target);
      }
    }, { rootMargin: '400px 0px' });
  }
  function attach(row) {
    if (!row || row.dataset.ldWatch === '1') return;
    row.dataset.ldWatch = '1';
    if (io) io.observe(row); else fire(row);
  }
  function watch(scope) {
    if (!scope || !scope.querySelectorAll) return;
    var rows = scope.querySelectorAll('.ld-swatches');
    for (var i = 0; i < rows.length; i++) attach(rows[i]);
  }
  function boot() {
    watch(document);
    /* 集合页 facets 筛选/翻页 与 产品页 related-products 都是 innerHTML 注入的（内联 script 不执行），
       所以这里用 MutationObserver 动态补挂，保证后注入的卡片一样有 hover 联动与预载 */
    if (window.MutationObserver) {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var add = muts[i].addedNodes;
          for (var j = 0; j < add.length; j++) {
            var n = add[j];
            if (!n || n.nodeType !== 1) continue;
            if (n.classList && n.classList.contains('ld-swatches')) attach(n);
            watch(n);
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
